// @flow
import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import ServiceOption from './ServiceOption';
import config from '../../../config';
import I18n from '../../../lib/i18n';
import theme from '../../../theme-config';

class ServiceOptions extends Component<Props> {
  styles = getStyles();

  componentDidMount() {
    if (this.props.options && this.props.selectedOptions) {
      this.props.validateSelectedOptions(this.props.options);
    }
  }

  isSelected = (selectedOptions: Object[], option: Object) =>
    selectedOptions.some(selectedOption => selectedOption.ouid === option.ouid);

  compareAddOn = (optionA: Object, optionB: Object) => {
    if (optionA.name < optionB.name) {
      return -1;
    }
    return 1;
  };

  render() {
    const styles = this.styles;
    const { options, priceKey, selectedOptions, addOptionToNewOffer } = this.props;

    if (!options || !options.length) return null;

    return (
      <>
        <View style={styles.container}>
          <View style={styles.titleContainer}>
            <Text style={styles.title}>{I18n.t('serviceOptions')}</Text>
          </View>
          {options.sort(this.compareAddOn).map((option, index) => (
            <ServiceOption
              key={index}
              currency={config.currency}
              name={option.name}
              characteristic={option.characteristics?.[0]}
              price={option.price[priceKey] || 0}
              periodicity={option.periodicity || { type: 'MONTH', number: 1 }}
              selected={this.isSelected(selectedOptions, option)}
              onSelect={() => addOptionToNewOffer(option)}
              onUnselect={() => addOptionToNewOffer(undefined, option)}
            />
          ))}
        </View>
        <View style={styles.separator} />
      </>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    container: {
      marginHorizontal: 20,
    },
    titleContainer: {
      marginBottom: 10,
    },
    title: {
      fontSize: 18,
    },
    separator: {
      backgroundColor: theme.gray.normal,
      opacity: 0.25,
      height: 2,
      marginTop: 14,
    },
  });

type Props = {
  options: Object[],
  selectedOptions: Object[],
  addOptionToNewOffer: Function,
  validateSelectedOptions: Function,
  priceKey: string,
};

export default ServiceOptions;
